import { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useSearchParams } from 'react-router-dom';
import Container from '@mui/material/Container';
import MKBox from 'components/MaterialKit/MKBox';
import { handleErrorResponse } from 'utils/general';
import { withLoading } from 'utils/hoc';
import { useAuth } from 'contexts/auth';
import { getLocaleMap } from 'utils/locales';
import { getModel, importModelCsv } from 'api/monitors';
import { Grid } from '@mui/material';
import MKTypography from 'components/MaterialKit/MKTypography';
import { getFileData } from 'utils/file';
import { get } from 'lodash';
import { createBigFile } from 'api/files';

const ImportModelSection = ({
  ...props
}) => {
  const [lm, setLm] = useState({});

  useEffect(() => {
    getLocaleMap(['labels_edit', 'labels_create'])
      .then((response) => {
        setLm(response);
      });
  }, []);

  const { setAuth } = useAuth();

  const fileInputRef = useRef(null);
  const [csvFile, setCsvFile] = useState();
  const [imageFileData, setImageFileData] = useState();

  const handleChangeFile = useCallback(async (event) => {
    const binaryData = [];
    if (event.target.files.length > 0) {
      console.log(event.target.files)
      binaryData.push(event.target.files[0]);
      // const file = window.URL.createObjectURL(new Blob(binaryData, { type: 'text/csv' }))
      // const file = event.target.files[0];
      const res = await getFileData(event.target.files[0]);
      setCsvFile(res);
      console.log(res)
      // setImageFileData(res);
    }
  }, []);

  const handleDeleteImageFile = useCallback(() => {
    setCsvFile(null);
  }, []);

  const handleImageUploadClick = () => {
    fileInputRef.current?.click();
  };

  const onUploadFile = useCallback(() => {
    if (csvFile) {
      return importModelCsv(csvFile)
        .then(() => {
          setImageFileData(null);
          alert('Uploaded Successfully');
        })
        .catch((err) => {
          handleErrorResponse(err, setAuth);
        });
    }
  }, [csvFile, setAuth]);
  return (
    <MKBox flex={1} mt="1rem">
      <MKBox display="flex" flexDirection="row" justifyContent="flex-end" alignItems="center">
        <MKTypography color="black" mr="1rem">
          {csvFile && csvFile.file_name}
        </MKTypography>
        {csvFile ? (
          <MKBox
            onClick={onUploadFile}
            display="flex"
            padding="5px"
            justifyContent="center"
            mr="1rem"
            width="180px"
            style={{ cursor: 'pointer', backgroundColor: '#114c86', border: '1px solid black', color: 'white' }}
          >
            Confirm Import
          </MKBox>
        )
          : (
            <MKBox
              onClick={handleImageUploadClick}
              display="flex"
              padding="5px"
              justifyContent="center"
              mr="1rem"
              width="140px"
              style={{ cursor: 'pointer', backgroundColor: '#114c86', border: '1px solid black', color: 'white' }}
            >
              <input
                ref={fileInputRef}
                type="file"
                accept="text/csv"
                style={{ display: 'none' }}
                onChange={(e) => handleChangeFile(e)}
              />
              Import CSV
            </MKBox>
          )}
        {csvFile && (
          <MKBox
            display="flex"
            padding="5px"
            justifyContent="center"
            width="140px"
            onClick={handleDeleteImageFile}
            style={{ cursor: 'pointer', backgroundColor: '#c20000', border: '1px solid black', color: 'white' }}
          >
            Delete
          </MKBox>
        )}
      </MKBox>
    </MKBox>
  );
};

ImportModelSection.propTypes = {
};

export default ImportModelSection;
